<template>
  <gd-modal
    ref="modalBlockedUser"
    name="modal-blocked-user"
    width="80%"
    :title="title"
    :hideClose="blockedUserCode !== 1"
    :noOverflow="true"
    @closed="$emit('close')"
  >
    <div class="p-4 pb-8 text-center">
      <div v-if="billing">
        <billing-plans v-if="blockedUserCode === 3" />
        <account-billing v-else></account-billing>
      </div>
      <div v-else>
        <div v-if="blockedUserCode === 1">
          <div class="p-4 pb-8">
            {{ $t('frontend_groovepages_block_user_dialogue_message') }}
          </div>
          <gd-button variant="shadowPrimary" primary @click="enableBilling">
            {{ $t('frontend_groovepages_update_payment_status') }}
          </gd-button>
        </div>
        <div v-if="blockedUserCode === 3">
          <div class="p-4 pb-8">
            {{ $t('free_plan_ended') }}
          </div>
          <div class="space-x-8">
            <gd-button variant="shadow" class="border text-grey-700" @click="goToAffiliateArea">
              {{ $t('go_to_affiliate_area') }}
            </gd-button>
            <gd-button variant="shadowPrimary" primary @click="goToUpgrade">
              {{ $t('free_plan_upgrade_button') }}
            </gd-button>
          </div>
        </div>
      </div>
    </div>
  </gd-modal>
</template>

<script>
import GdButton from './Button';
import GdModal from './Modal';
import AccountBilling from './settings/billing-settings/account-billing/billing';
import BillingPlans from './AccountBilling';

export default {
  name: 'BlockedUserModal',
  props: {
    blockedUserCode: {
      type: Number,
      default: 1
    },

  },
  components: { AccountBilling, GdModal, GdButton, BillingPlans },
  data() {
    return {
      title: 'Attention valued customer!',
      billing: false
    };
  },
  mounted() {
    this.$refs.modalBlockedUser.open();
  },
  methods: {
    enableBilling() {
      this.billing = true;
      this.title = '';
    },
    goToUpgrade() {
      window.open('https://upgrade.groove.cm/upgrade/95519a5f-3e2a-45ec-bd5d-7e7e51da2abc', '_blank');
    },
    goToAffiliateArea() {
      window.location.href = '/groovesell/affiliates-dashboard';
    }
  }
};
</script>
